import { render, staticRenderFns } from "./ReportsOverview.vue?vue&type=template&id=2e805c40&"
import script from "./ReportsOverview.vue?vue&type=script&lang=js&"
export * from "./ReportsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports